<div echarts class="chart" [options]="chartOptions"></div>
